import { render, staticRenderFns } from "./UserDefinedGroupPop.vue?vue&type=template&id=4be838b2&scoped=true"
import script from "./UserDefinedGroupPop.vue?vue&type=script&lang=js"
export * from "./UserDefinedGroupPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be838b2",
  null
  
)

export default component.exports